"use client";

import { c as _c } from "react-compiler-runtime";
import { motion } from "motion/react";
export default function ScanLineOverlay() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      top: ["0%", "100%", "0%"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pointer-events-none absolute inset-0 overflow-hidden"><motion.div animate={t0} className="via-primary/60 absolute right-0 left-0 h-[2px] bg-gradient-to-r from-transparent to-transparent" transition={{
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}